import { render, staticRenderFns } from "./BlackGoldWithdrawPage.vue?vue&type=template&id=ff74efd6"
import script from "./BlackGoldWithdrawPage.vue?vue&type=script&lang=js"
export * from "./BlackGoldWithdrawPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports